import instanceService from './instance'

import { REPORT_SERVER_URL } from '../helpers/constants'

let instance = instanceService.instance(REPORT_SERVER_URL)

export const reportService = {
  generateReport,
  generateContentAutoLombard,
  getLastReport,
  getAdImage,
  adImage,
  deleteAdImage,
  loadAcceptanceCertificate,
  getAcceptanceCertificate,
  getClientsCountReport,
  generateDebtOverloadReport,
  fetchDebtReport
}

function getAcceptanceCertificate(data) {
  const options = {
    method: 'GET',
    url: `/acceptance_certificates/${data.transferId}`,
  }
  return instance(options)
}

function loadAcceptanceCertificate(data) {
  const formData = new FormData();
  formData.append('file', data.file);
  const options = {
    method: 'POST',
    url: `/acceptance_certificates/${data.transferId}`,
    data: formData
  }
  return instance(options)
}

function generateReport(code, data) {
  const options = {
    method: 'POST',
    url: '/generate/' + code,
    data
  }
  return instance(options)
}

function generateContentAutoLombard(dealId) {
  const options = {
    method: 'GET',
    url: `/deal/${dealId}/reports`
  }
  return instance(options)
}

function getClientsCountReport(code, data) {
  const options = {
    method: 'POST',
    url: '/details/' + code,
    data
  }
  return instance(options)
}

function getLastReport(type, cashBoxId) {
  const options = {
    method: 'GET',
    url: `/last/${type}/${cashBoxId}`
  }
  return instance(options)
}
function getAdImage(branchId) {
  const options = {
    method: 'GET',
    url:`/advert/${branchId}`
  }
  return instance(options)
}
function adImage(name, branchId, advertImage) {
  const options = {
    method: 'POST',
    data: {name, branchId, advertImage},
    url: `/advert/add`,

  }
  return instance(options)
}
function deleteAdImage(branchId) {
  const options = {
    method: 'DELETE',
    url:`/advert/delete/${branchId}`
  }
  return instance(options)
}

function generateDebtOverloadReport(code, data) {
  const options = {
    method: 'POST',
    url: '/generate/' + code,
    data
  }
  return instance(options)
}

function fetchDebtReport(data) {
  const options = {
    method: 'POST',
    url: '/debt-load',
    data
  }
  return instance(options)
}
